<template>
  <div class="bannerImg">
    <v-image
      :height="$vuetify.breakpoint.mdAndDown ? '250' : '350'"
      max-width="1920"
      :src="url || cover"
      :waitLoading="waitLoading"
      :position="$vuetify.breakpoint.mdAndDown ? 'center bottom' : 'center center'"
    />
    <slot></slot>
    <v-card class="editTag" v-if="isEdit" @click="$refs.fileInputCover.click()">
      <!-- icon -->
      <v-icon
        class="far fa-camera"
        size="16"
      ></v-icon>
      <span
        class="editTag__text subtitle-2"
      >
        <translate>Edit cover photo</translate>
      </span>
    </v-card>
    <input
      v-show="false"
      ref="fileInputCover"
      type="file"
      name="image"
      accept="image/*"
      @change="onChange"
    />
    <InputCrop
      :title="$gettext('Cover Uploader')"
      :aspectRatio="3.56"
      :file="fileUpload"
      ref="CoverUploader"
      :closeOnCrop="false"
      force200KB
      @cropped="onCroppedFile"
      :cropOptions="{maxWidth: 1920}"
    />
  </div>
</template>
<script>
import InputCrop from "@/components/Forms/InputCrop";
export default {
  name: "ImageWall",
  props: {
    isEdit: {type: Boolean, default: false},
    waitLoading: {type: Boolean, default: false},
    url: {type: String, default: null}
  },
  components: { InputCrop },
  data: () => ({
    fileUpload: true,
  }),
  computed: {
    cover() {
      return (
        this.url ||
        this.$store.state.auth.user.cover ||
        this.imgUrl('default-banner.jpg')
      );
    },
  },
  methods: {
    onChange(e) {
      let vm = this;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        vm.fileUpload = e.target.result; // change data image
        vm.$refs.CoverUploader.open(true); // show popup
      };
    },
    async onCroppedFile(file) {
      this.$emit("cropped", file);
    },
  },
};
</script>
